<template>
  <InputComponent v-bind="$attrs" class="field-combine-selector">
    <InputComponent
      :required="required.includes(category.key)"
      v-for="(category, categoryIndex) in itemsComp"
      v-bind="category"
      :disabled="isDisabled(category.disabledIf)"
      class="field-combine-selector__category"
    >
      <template #default>
        <select
          class="field-combine-selector__element"
          :class="{ 'field-combine-selector__element--placeholder': isUnselected }"
          v-bind="$attrs"
          :value="category.value"
          @input="$ev => setValue($ev, category, categoryIndex)"
        >
          <option
            v-if="placeholder"
            :value="undefined"
            :disabled="required.includes(category.key)"
            dir="ltr"
          >
            {{ placeholder }}
          </option>
          <option v-for="(item, index) in category.items" :key="index" :value="getItemValue(item)">
            {{ item.title }}
          </option>
        </select>
        <Icon class="field-combine-selector__icon" :icon="['fal', 'angle-down']" size="lg" />
      </template>
    </InputComponent>
    <InputComponent
      class="field-combine-selector__result"
      :value="value"
      :label="$t('result')"
      :disabled="true"
    >
    </InputComponent>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import Icon from '@kvass/vue2-icon'

export default {
  props: {
    value: [String, Array],
    placeholder: {
      type: String,
      default() {
        return this.$t('select') + '...'
      },
    },
    items: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    default: String,
  },
  data() {
    return {
      itemsComp: [],
      required: [],
    }
  },
  computed: {
    isUnselected() {
      return this.placeholder && this.value === undefined
    },
  },

  methods: {
    hasRequired(item, category) {
      if (!item.requiredIf) return false
      return item.requiredIf === category
    },
    getItemValue(item) {
      return item.value || item.title
    },

    setValue(val, category, index) {
      let value = val.target.value

      if (!this.required.includes(category.key)) {
        this.required = []
      }

      //use combine with other value if defined
      const combineIndex = this.itemsComp.findIndex(i => i.key === category.combineWidth)
      const combineItem = this.itemsComp[combineIndex] || {}
      const hasRequired = value && this.hasRequired(combineItem, category.key)

      if (hasRequired) {
        this.required.push(combineItem.key)
      }

      let combineValue = hasRequired ? this.getItemValue(combineItem.items[0]) : combineItem.value

      //settings current value intro correct item
      this.itemsComp = this.itemsComp.map(i => {
        let val = i.value

        if (i.key === combineItem.key && combineValue) {
          val = combineValue
        }
        if (i.key === category.key) {
          val = value
        }
        return {
          ...i,
          value: val,
        }
      })

      if (combineValue) {
        value = [value]
        if (combineIndex < index) {
          value.unshift(combineValue)
        } else {
          value.push(combineValue)
        }
        value = value.join(' ')
      }

      //emit value or combined value
      this.$emit('input', value)
    },
    isDisabled(disabledIf) {
      //disabledIf is a reference another item
      if (!disabledIf) return

      //disabledIf can be multible
      const disabledIfValue = disabledIf.includes(':') ? disabledIf.split(':') : [disabledIf]
      const categoryInUse = this.itemsComp.filter(i => i.value).map(i => i.key)

      return categoryInUse.some(c => disabledIfValue.includes(c))
    },
  },
  created() {
    //build items
    this.itemsComp = this.categories.map(c => {
      let items = [...(this.items.filter(i => i.category === c.key) || [])]

      let value = c.combineWith && this.value ? this.value.split(' ') : this.value

      let defaultValue = this.value
        ? items.find(i => value.includes(this.getItemValue(i))) || {}
        : {}

      const hasRequired = this.categories.find(i => i.key === c.requiredIf)

      if (defaultValue.category === c.key && hasRequired && !this.isDisabled(c.disabledIf)) {
        this.required.push(c.key)
      }
      return { ...c, items, value: this.getItemValue(defaultValue) }
    })
  },

  components: {
    InputComponent,
    Icon,
  },
}
</script>

<style lang="scss">
.field-combine-selector {
  & > .elder-input__wrapper > .elder-input__field {
    border: none;
    padding: 1rem;
    background-color: #f7f7f7;

    & > .elder-input__value {
      flex-wrap: wrap;
      gap: 1rem;
    }
  }

  &__category {
    flex-grow: 1;
  }
  &__result {
    flex-basis: 100%;
    .elder-input__field {
      font-weight: bold;
      &--disabled:before {
        opacity: 0.2;
        --vue-elder-input-color: hsl(var(--secondary-h), var(--secondary-s), 92%);
      }
    }
  }

  &__element {
    appearance: none;
    width: 100%;
    height: 100%;
    padding: 1.1rem 2.5rem 1.1rem 1.1rem;
    border-radius: var(--border-radius);

    &--placeholder {
      opacity: 0.3;
    }

    &:focus-visible {
      outline: 1px solid var(--primary);
    }
  }

  &__icon {
    position: absolute;
    right: 1.1rem;
    top: 50%;
    transform: translateY(-45%);
    color: inherit;
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
